export default "__VITE_ASSET__D5DdUv$u__"